import { z } from 'zod';
import { ENGAGEMENT_ENTITY_TYPES, ENGAGEMENT_EVENT_KEYS } from '../enums';
import { uuidSchema } from './common';

// Fire-and-forget engagement ingest (docs/04, decision D-B2).
export const engagementEventSchema = z.object({
  eventKey: z.enum(ENGAGEMENT_EVENT_KEYS),
  entityType: z.enum(ENGAGEMENT_ENTITY_TYPES),
  entityId: uuidSchema,
});
export type EngagementEventPayload = z.infer<typeof engagementEventSchema>;

export const analyticsQuerySchema = z.object({
  days: z.coerce.number().int().min(1).max(365).default(30),
});
export type AnalyticsQuery = z.infer<typeof analyticsQuerySchema>;
